import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MentionOnSearchTypes } from 'ng-zorro-antd/mention';
import { SubOrganisationsTableComponent } from 'src/app/services/crud-table/tables/buyer/sub-organisations-table.component';
import { CREATE_SUB_ORGANISATION_MODAL_STYLE } from '../../../constants';

@Component({
	selector: 'app-sub-organisations',
	templateUrl: './sub-organisations.component.html',
	styleUrls: ['./sub-organisations.component.scss']
})

export class SubOrganisationsComponent extends SubOrganisationsTableComponent implements OnInit, OnDestroy {

	createSubOrganisationModalVisible: boolean = false;
	createSubOrganisationForm: FormGroup;
	createSubOrganisationModalStyle = CREATE_SUB_ORGANISATION_MODAL_STYLE;
	inputValue?: string;
	suggestions: object[] = [];

	users = [
		{
			name: 'ME',
			email: 'me@org.com'
		},
		{
			name: 'Armin Doe',
			email: 'jd@org.com'
		},
		{
			name: 'Bernd Doe',
			email: 'bd@org.com'
		},
		{
			name: 'Chris Doe',
			email: 'cd@org.com'
		},
		{
			name: 'Frank Doe',
			email: 'd@org.com'
		}

	];

	constructor(
		private formBuilder: FormBuilder,
		@Inject(HttpClient) http
	) {
		super(http);
	}

	ngOnInit(): void {
		this.createSubOrganisationForm = this.formBuilder.group({
			organisationName: ['', [Validators.required]],
			person: [[], [Validators.required]]
		});
	}

	listOfData = [
		{
			role: 'Organisation A',
			admin: 'admin@org.com'
		},
		{
			role: 'Organisation B',
			admin: 'admin@orgb.de'
		},
		{
			role: 'Organisation C',
			admin: 'admin@orgc.jp'
		}
	];

	listOfColumn = [
		{
			title: 'Roles',
			compare: null,
			sortOrder: null,
			sortFn: (a: object, b: object) => a['role'].localeCompare(b['role']),
			sortDirections: ['ascend', 'descend', null],
			width: '85%'
		},
		{
			title: 'Admin',
			compare: null,
			sortOrder: null,
			sortFn: (a: object, b: object) => a['admin'].localeCompare(b['admin']),
			sortDirections: ['ascend', 'descend', null],
			width: '15%'
		}
	];

	/**
	 * Handle create sub-organisation form submission.
	 * @param formValues : values of all fields of user invite form
	 */
	handleOk(formValues: object): void {
		this.createSubOrganisationModalVisible = false;
		this.createSubOrganisationForm.reset();
	}

	/**
	 * Handle create sub-organisation form close.
	 */
	handleCancel(formValues: object): void {
		this.createSubOrganisationModalVisible = false;
		this.createSubOrganisationForm.reset();
	}

	/**
	 * Handle create sub organisation popup modal opening
	*/
	displayCreateSubOrganisationModal(): void {
		this.createSubOrganisationModalVisible = true;
	}

	/**
	 * Search event on mention input field
	 */
	onSearchChange({ value, prefix }: MentionOnSearchTypes): void {
		this.suggestions = this.users;
	}

	/**
	 * Replace drop down values
	 */
	valueWidth(data): string {
		return data.name;
	}

	/**
	 * Handle search bar input change
	 * @param searchTerm : search string
	 */
	onChange(searchTerm: string): void {
		const dataObject = {
			searchTerm: searchTerm.trim()
		};

		this.findSubOrganisations(dataObject).subscribe((response) => {
			//console.log('sub-organisations', response);
		});
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((subscription) => subscription.unsubscribe());
	}
}
